import * as React from 'react';
import './MessageBar.scss';
import ErrorMessage from '../Notifications/ErrorMessage/ErrorMessage';
import Success from '../Notifications/Success/Success';

interface MessageBarInterface {
  messageType: MessageType;
  messageText: string;
  id?: string;
}

const MessageBar = ({ messageType, messageText, id }: MessageBarInterface) => {
  const content = (() => {
    if (messageType === 'error') {
      return <ErrorMessage errorText={messageText} errorId={id} />;
    }
    /* istanbul ignore else: (UI-5482) */
    if (messageType === 'success') {
      return <Success successText={messageText} successId={id} />;
    }
  })();
  return <div className="MessageBar">{content}</div>;
};

export default MessageBar;
